var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Notifications")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Toasts are as flexible as you need and have very little required markup. At a minimum, we require a single element to contain your “toasted” content and strongly encourage a dismiss button.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-1"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-toast visible static no-auto-hide no-close-button>\n  <template v-slot:toast-title>\n    <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n      <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n    </svg>\n    <strong class=\"mr-auto\">Bootstrap</strong>\n    <small>11 mins ago</small>\n    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">×</span>\n    </button>\n  </template>\n  Hello, world! This is a toast message.\n</b-toast>\n")])])])])]), _c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Hello, world! This is a toast message. ")])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Stacking")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("When you have multiple toasts, we default to vertically stacking them in a readable manner.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-2"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-toast visible static no-auto-hide no-close-button>\n  <template v-slot:toast-title>\n    <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n      <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n    </svg>\n    <strong class=\"mr-auto\">Bootstrap</strong>\n    <small class=\"text-muted\">just now</small>\n    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">×</span>\n    </button>\n  </template>\n  See? Just like this.\n</b-toast>\n<b-toast visible static no-auto-hide no-close-button>\n  <template v-slot:toast-title>\n    <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n      <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n    </svg>\n    <strong class=\"mr-auto\">Bootstrap</strong>\n    <small class=\"text-muted\">2 seconds ago</small>\n    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">×</span>\n    </button>\n  </template>\n  Heads up, toasts will stack automatically\n</b-toast>\n")])])])])]), _c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-muted"
              }, [_vm._v("just now")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" See? Just like this. ")]), _c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-muted"
              }, [_vm._v("2 seconds ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Heads up, toasts will stack automatically ")])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Notifications horizontally and/or vertically")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("You can also get fancy with flexbox utilities to align toasts horizontally and/or vertically.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-3"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<div class=\"p-3 bg-dark\">\n  <div aria-live=\"polite\" aria-atomic=\"true\" class=\"d-flex justify-content-center align-items-center\" style=\"min-height: 200px;\">\n    <b-toast visible static no-auto-hide no-close-button>\n      <template v-slot:toast-title>\n        <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n          <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n        </svg>\n        <strong class=\"mr-auto\">Bootstrap</strong>\n        <small>11 mins ago</small>\n        <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n          <span aria-hidden=\"true\">×</span>\n        </button>\n      </template>\n      Hello, world! This is a toast message.\n    </b-toast>\n  </div>\n</div>\n")])])])])]), _c('div', {
          staticClass: "p-3 bg-dark"
        }, [_c('div', {
          staticClass: "d-flex justify-content-center align-items-center",
          staticStyle: {
            "min-height": "200px"
          },
          attrs: {
            "aria-live": "polite",
            "aria-atomic": "true"
          }
        }, [_c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Hello, world! This is a toast message. ")])], 1)])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Notifications")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Toasts are as flexible as you need and have very little required markup. At a minimum, we require a single element to contain your “toasted” content and strongly encourage a dismiss button.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-4"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<div class=\"p-3 bg-dark\">\n  <b-toast visible static no-auto-hide no-close-button>\n    <template v-slot:toast-title>\n      <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n        <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n      </svg>\n      <strong class=\"mr-auto\">Bootstrap</strong>\n      <small>11 mins ago</small>\n      <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n        <span aria-hidden=\"true\">×</span>\n      </button>\n    </template>\n    Hello, world! This is a toast message.\n  </b-toast>\n</div>\n")])])])])]), _c('div', {
          staticClass: "p-3 bg-dark"
        }, [_c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Hello, world! This is a toast message. ")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Stacking Placement")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Place toasts with custom CSS as you need them. The top right is often used for notifications, as is the top middle. If you’re only ever going to show one toast at a time, put the positioning styles right on the "), _c('code', [_vm._v(".toast")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-5"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<div class=\"p-3 bg-dark\">\n  <div aria-live=\"polite\" aria-atomic=\"true\" style=\"position: relative; min-height: 200px;\">\n    <b-toast visible static no-auto-hide no-close-button toast-class=\"position-absolute\">\n      <template v-slot:toast-title>\n        <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n          <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n        </svg>\n        <strong class=\"mr-auto\">Bootstrap</strong>\n        <small>11 mins ago</small>\n        <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n          <span aria-hidden=\"true\">×</span>\n        </button>\n      </template>\n      Hello, world! This is a toast message.\n    </b-toast>\n  </div>\n</div>\n<p class=\"mt-3\">For systems that generate more notifications, consider using a wrapping element so they can easily stack.</p>\n<div class=\"bg-dark p-3 mt-3\">\n  <div aria-live=\"polite\" aria-atomic=\"true\" style=\"position: relative; min-height: 200px;\">\n    <div style=\"position: absolute; top: 0; right: 0;\">\n    <b-toast visible static no-auto-hide no-close-button>\n      <template v-slot:toast-title>\n        <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n          <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n        </svg>\n        <strong class=\"mr-auto\">Bootstrap</strong>\n        <small class=\"text-muted\">just now</small>\n        <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n          <span aria-hidden=\"true\">×</span>\n        </button>\n      </template>\n      See? Just like this.\n    </b-toast>\n    <b-toast visible static no-auto-hide no-close-button>\n      <template v-slot:toast-title>\n        <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n          <rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect>\n        </svg>\n        <strong class=\"mr-auto\">Bootstrap</strong>\n        <small class=\"text-muted\">2 seconds ago</small>\n        <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">\n          <span aria-hidden=\"true\">×</span>\n        </button>\n      </template>\n      Heads up, toasts will stack automatically\n    </b-toast>\n    </div>\n  </div>\n</div>\n")])])])])]), _c('div', {
          staticClass: "p-3 bg-dark"
        }, [_c('div', {
          staticStyle: {
            "position": "relative",
            "min-height": "200px"
          },
          attrs: {
            "aria-live": "polite",
            "aria-atomic": "true"
          }
        }, [_c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": "",
            "toast-class": "position-absolute"
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Hello, world! This is a toast message. ")])], 1)]), _c('p', {
          staticClass: "mt-3"
        }, [_vm._v("For systems that generate more notifications, consider using a wrapping element so they can easily stack.")]), _c('div', {
          staticClass: "bg-dark p-3 mt-3"
        }, [_c('div', {
          staticStyle: {
            "position": "relative",
            "min-height": "200px"
          },
          attrs: {
            "aria-live": "polite",
            "aria-atomic": "true"
          }
        }, [_c('div', {
          staticStyle: {
            "position": "absolute",
            "top": "0",
            "right": "0"
          }
        }, [_c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-muted"
              }, [_vm._v("just now")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" See? Just like this. ")]), _c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": ""
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#007aff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-muted"
              }, [_vm._v("2 seconds ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Heads up, toasts will stack automatically ")])], 1)])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Notifications")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Toasts are as flexible as you need and have very little required markup. At a minimum, we require a single element to contain your “toasted” content and strongly encourage a dismiss button.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "notification-6"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-toast visible static no-auto-hide no-close-button toast-class=\"bg-primary\" body-class=\"text-white\"  header-class=\"bg-primary text-white\">\n  <template v-slot:toast-title>\n    <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n      <rect width=\"100%\" height=\"100%\" fill=\"#fff\"></rect>\n    </svg>\n    <strong class=\"mr-auto text-white\">Bootstrap</strong>\n    <small class=\"text-white\">11 mins ago</small>\n    <button type=\"button\" class=\"ml-2 mb-1 close text-white\" data-dismiss=\"toast\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">×</span>\n    </button>\n  </template>\n  See? Just like this.\n</b-toast>\n<b-toast variant=\"success\" visible static no-auto-hide no-close-button toast-class=\"bg-success mt-3\" body-class=\"text-white\"  header-class=\"bg-success text-white\">\n  <template v-slot:toast-title>\n    <svg class=\"bd-placeholder-img rounded mr-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\" role=\"img\">\n      <rect width=\"100%\" height=\"100%\" fill=\"#fff\"></rect>\n    </svg>\n    <strong class=\"mr-auto text-white\">Bootstrap</strong>\n    <small class=\"text-white\">11 mins ago</small>\n    <button type=\"button\" class=\"ml-2 mb-1 close text-white\" data-dismiss=\"toast\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">×</span>\n    </button>\n  </template>\n  Heads up, toasts will stack automatically\n</b-toast>\n")])])])])]), _c('b-toast', {
          attrs: {
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": "",
            "toast-class": "bg-primary",
            "body-class": "text-white",
            "header-class": "bg-primary text-white"
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#fff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto text-white"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-white"
              }, [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close text-white",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" See? Just like this. ")]), _c('b-toast', {
          attrs: {
            "variant": "success",
            "visible": "",
            "static": "",
            "no-auto-hide": "",
            "no-close-button": "",
            "toast-class": "bg-success mt-3",
            "body-class": "text-white",
            "header-class": "bg-success text-white"
          },
          scopedSlots: _vm._u([{
            key: "toast-title",
            fn: function fn() {
              return [_c('svg', {
                staticClass: "bd-placeholder-img rounded mr-2",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "preserveAspectRatio": "xMidYMid slice",
                  "focusable": "false",
                  "role": "img"
                }
              }, [_c('rect', {
                attrs: {
                  "width": "100%",
                  "height": "100%",
                  "fill": "#fff"
                }
              })]), _c('strong', {
                staticClass: "mr-auto text-white"
              }, [_vm._v("Bootstrap")]), _c('small', {
                staticClass: "text-white"
              }, [_vm._v("11 mins ago")]), _c('button', {
                staticClass: "ml-2 mb-1 close text-white",
                attrs: {
                  "type": "button",
                  "data-dismiss": "toast",
                  "aria-label": "Close"
                }
              }, [_c('span', {
                attrs: {
                  "aria-hidden": "true"
                }
              }, [_vm._v("×")])])];
            },
            proxy: true
          }])
        }, [_vm._v(" Heads up, toasts will stack automatically ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }